import React from "react";

export default function PageHeader({ eyebrow, title, description, action, testid }) {
    return (
        <div className="mb-8 flex items-end justify-between gap-6" data-testid={testid}>
            <div>
                {eyebrow && (
                    <div className="text-[11px] uppercase tracking-[0.25em] text-stone-500 mb-2">
                        {eyebrow}
                    </div>
                )}
                <h1 className="font-heading text-4xl text-orchid-700 leading-tight">{title}</h1>
                {description && (
                    <p className="text-stone-600 mt-2 max-w-2xl text-sm leading-relaxed">{description}</p>
                )}
            </div>
            {action && <div className="shrink-0">{action}</div>}
        </div>
    );
}
